import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { QueryPanelCriteriaMessage, TreeViewFilterDataItem } from '../models/messages/query-panel-messages';

@Injectable({
  providedIn: 'root'
})

// Shared service for the right hand side of a isg-query-panel.
// It's used to communicate between the treeview components, the criteria control
// at the top of the panel, and the search box.
export class QueryPanelConnectorService {
  /*-------------------------- private variables --------------------------*/
  private subject = new Subject<QueryPanelCriteriaMessage>();
  /*-------------------------- properties --------------------------*/
  public get observerCount() {
    return this.subject.observers.length;
  }

  /*-------------------------- public functions --------------------------*/

  public addItem(item: TreeViewFilterDataItem, isFromTreeView: boolean) {
    this.subject.next({ type: "add", item: item, isFromTreeView: isFromTreeView });
  }

  public removeItem(item: TreeViewFilterDataItem, isFromTreeView: boolean) {
    this.subject.next({ type: "delete", item: item, isFromTreeView: isFromTreeView });
  }

  public filter(filter: string) {
    this.subject.next({ type: "filter", filter: filter });
  }

  public clearItems() {
    this.subject.next({ type: "clear" });
  }

  public hasObservers(): boolean {
    return this.subject.observers.length > 0;
  }

  public isLoaded(controlName: string) {
    this.subject.next({ type: "isLoaded", control: controlName });
  }

  public loadAll(): number {
    this.subject.next({ type: "load" });
    return this.subject.observers.length;
  }

  public onMessage(): Observable<QueryPanelCriteriaMessage> {
    return this.subject.asObservable();
  }
}
